import { render, staticRenderFns } from "./PathReportViewerFrame.vue?vue&type=template&id=58117dc7&scoped=true&"
import script from "./PathReportViewerFrame.vue?vue&type=script&lang=js&"
export * from "./PathReportViewerFrame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58117dc7",
  null
  
)

export default component.exports